<section class="contact-page">
  <div class="contact-shell">
    <header class="contact-header">
      <span class="contact-eyebrow">HJÄLP OCH KONTAKT</span>
      <h1 class="sam-page-heading">Kontakt</h1>
      <p>Vi hjälper dig gärna när du har frågor om ditt konto eller våra tjänster.</p>
    </header>

    <div class="contact-content">
      <article class="contact-card contact-card-primary">
        <div class="contact-card-heading">
          <span class="contact-icon" aria-hidden="true">
            <mat-icon>support_agent</mat-icon>
          </span>
          <div>
            <span class="card-eyebrow">KUNDSERVICE</span>
            <h2>Kontakta oss</h2>
          </div>
        </div>

        <div class="contact-details">
          <a class="contact-detail" href="mailto:medlem@sampoolen.se">
            <mat-icon aria-hidden="true">mail_outline</mat-icon>
            <span>
              <small>E-post</small>
              <strong>medlem&#64;sampoolen.se</strong>
            </span>
            <mat-icon class="detail-arrow" aria-hidden="true">arrow_forward</mat-icon>
          </a>

          <a class="contact-detail" href="tel:+46851816440">
            <mat-icon aria-hidden="true">phone</mat-icon>
            <span>
              <small>Telefon</small>
              <strong>08-51 81 64 40</strong>
            </span>
            <mat-icon class="detail-arrow" aria-hidden="true">arrow_forward</mat-icon>
          </a>
        </div>
      </article>

      <article class="contact-card">
        <div class="contact-card-heading">
          <span class="contact-icon contact-icon-neutral" aria-hidden="true">
            <mat-icon>business</mat-icon>
          </span>
          <div>
            <span class="card-eyebrow">FÖRETAGET</span>
            <h2>SAMgruppen AB</h2>
          </div>
        </div>

        <dl class="company-details">
          <div>
            <dt>Organisationsnummer</dt>
            <dd>559012-7253</dd>
          </div>
          <div>
            <dt>Adress</dt>
            <dd>Hantverkargatan 52<br />112 31 Stockholm</dd>
          </div>
        </dl>
      </article>

      <article class="contact-card">
        <div class="contact-card-heading">
          <span class="contact-icon contact-icon-neutral" aria-hidden="true">
            <mat-icon>person_outline</mat-icon>
          </span>
          <div>
            <span class="card-eyebrow">VERKSTÄLLANDE DIREKTÖR</span>
            <h2>Staffan Moberg</h2>
          </div>
        </div>

        <a class="contact-detail contact-detail-compact" href="tel:+46762088099">
          <mat-icon aria-hidden="true">phone</mat-icon>
          <span>
            <small>Telefon</small>
            <strong>0762-088 099</strong>
          </span>
          <mat-icon class="detail-arrow" aria-hidden="true">arrow_forward</mat-icon>
        </a>
      </article>
    </div>
  </div>
</section>
